import { Component, Input } from '@angular/core';

import { LoadingComponent } from '../common/loading/loading.component';
import { ChatInfoComponent } from './chat-info/chat-info.component';
import { UsefulLinksComponent } from './useful-links/useful-links.component';
import { CallUsComponent } from './call-us/call-us.component';

@Component({
    selector: 'olb-app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
    imports: [LoadingComponent, ChatInfoComponent, UsefulLinksComponent, CallUsComponent]
})
export class ContactUsComponent  {
  @Input() dataLoaded = false;

  @Input() userAuthenticated = false;
}
